import { render, staticRenderFns } from "./questionnairerecord.vue?vue&type=template&id=1e2b077c&scoped=true&"
import script from "./questionnairerecord.vue?vue&type=script&lang=js&"
export * from "./questionnairerecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2b077c",
  null
  
)

export default component.exports